import {
  InputGroup,
  InputRightElement,
  Input as ChakraInput,
  Box,
} from "@chakra-ui/react";
import { useState } from "react";
import clsx from "classnames";

import Button from "../Button/Button";
import { VisibilityOffRounded, VisibilityRounded } from "@material-ui/icons";

const PasswordInput = ({ w, width, label, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);

  const visibility = clsx(isVisible ? "text" : "password");

  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <InputGroup>
      <ChakraInput
        w={w}
        width={width}
        borderRadius="16px"
        errorBorderColor="red.300"
        minH="56px"
        bg="#EFF0F7"
        border="1px solid transparent"
        variant="filled"
        _focus={{
          borderColor: "#06C344",
          boxShadow: "0 0 0 3px #06C3448f",
        }}
        {...props}
        type={visibility}
      />
      <InputRightElement
        h="100%"
        mr="12px"
        children={
          <Button
            bg="transparent"
            minW="0"
            size="sm"
            borderRadius="2"
            onClick={toggleVisibility}
          >
            {!isVisible ? (
              <Box as={VisibilityRounded} color="#A0A3BD" />
            ) : (
              <Box as={VisibilityOffRounded} color="#A0A3BD" />
            )}
          </Button>
        }
      />
    </InputGroup>
  );
};

export default PasswordInput;
